<div class="min-h-screen flex justify-content-center w-full flex-wrap">
  <div class="grid col-12 form-login p-0">
    <div class="col-6 image-reset-senha bg-cover"></div>
    <div class="col-6 align-items-center justify-content-center flex">
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="flex justify-content-between align-items-end">
          <h4>Redefinir senha</h4>
        </div>

        <div class="mb-3 col-12">
          <label class="inline-block w-auto white-space-nowrap mb-2 text-base mb-1">Senha</label>
          <div class="relative">
            <p-password [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}" type="password"
              formControlName="senha" [toggleMask]="true">
              <ng-template pTemplate="header">
                <h6>Escolha a senha</h6>
              </ng-template>
              <ng-template pTemplate="footer">
                <p-divider></p-divider>
                <p class="mt-2">Segurança da senha</p>
                <ul class="ps-4 ml-2 mt-0" style="line-height: 1.5; font-size: 12px;">
                  <li>Deve conter, ao menos, 8 caracteres</li>
                  <li>Deve conter, ao menos, uma letra minúscula</li>
                  <li>Deve conter, ao menos, uma letra maiúscula</li>
                  <li>Deve conter, ao menos, um número</li>
                  <li>Deve conter, ao menos, um caractere especial</li>
                </ul>
              </ng-template>
            </p-password>
            <span
              class="symbol-input100 pointer-events-none pl-3 bottom-0 left-0  absolute align-items-center flex text-lg w-full h-full">
              <i class="pi pi-key"></i>
            </span>
          </div>
          <div class="text-sm mt-1 text-red-500 mb-3 ml-2" *ngIf="f['senha'].touched && f['senha'].invalid">
            <div class="text-sm mt-1 text-red-500" *ngIf="f['senha'].errors?.['required']">
              Por favor, informe a senha.
            </div>
            <div class="text-sm mt-1 text-red-500" *ngIf="f['senha'].errors?.['minlength']">
              A senha deve ter pelo menos 8 caracteres.
            </div>
            <div class="text-sm mt-1 text-red-500" *ngIf="f['senha'].errors?.['pattern']">
              A senha deve conter uma combinação de letras maiúsculas, minúsculas, números e caracteres especiais.
            </div>
          </div>
        </div>

        <div class="mb-3 col-12">
          <label class="inline-block w-auto white-space-nowrap mb-2 text-base mb-1">Confirmar a Senha</label>
          <div class="relative">
            <p-password [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}" type="password"
              formControlName="senhaConfirmacao" [toggleMask]="true">
            </p-password>
            <span
              class="symbol-input100 pointer-events-none pl-3 bottom-0 left-0 eabsolute align-items-center flex text-lg w-full h-full">
              <i class="pi pi-key"></i>
            </span>
          </div>
          <div class="text-sm mt-1 text-red-500 mb-3 ml-2"
            *ngIf="(f['senhaConfirmacao'].touched || f['senhaConfirmacao'].dirty) && (f['senhaConfirmacao'].invalid || form.hasError('passwordsDoNotMatch'))">
            <div class="text-sm mt-1 text-red-500" *ngIf="f['senhaConfirmacao'].errors?.['required']">
              Por favor, confirme a senha.
            </div>
            <div class="text-sm mt-1 text-red-500" *ngIf="form.hasError('passwordsDoNotMatch')">
              As senhas precisam corresponder.
            </div>
          </div>
        </div>

        <div class="mt-4 col-12">
          <p-button label="Redefinir senha" type="submit" [disabled]="form.invalid" styleClass="login100-form-btn">
          </p-button>
        </div>
        <div class="text-center mt-4">
          <a class="m-0 hover:text-blue-300 btn btn-link" style="text-decoration: none;" href="/login">Voltar para
            Login</a>
        </div>
      </form>
    </div>
  </div>
</div>